import type {
  Excursion,
  ExcursionGroup,
  ExcursionGroupRequest,
  ExcursionRequest,
  ExcursionCustomer,
  ExcursionUser,
} from "api/excursions/Excursion.typed";
import { GROUP_DEFAULT_COLOR } from "utils/colorPalette";

function groupColorOrFallback(hex: string | undefined): string {
  return hex && String(hex).trim() ? hex : GROUP_DEFAULT_COLOR;
}

export function toGroupPayload(g: ExcursionGroup): ExcursionGroupRequest {
  const groupColor = groupColorOrFallback(g.color);
  const excursion_customers: ExcursionCustomer[] = (g.excursion_customers ?? []).map(
    (c): ExcursionCustomer => ({
      id: c.id,
      color: c.color && String(c.color).trim() ? c.color : groupColor,
      comments: c.comments,
    }),
  );
  const excursion_users: ExcursionUser[] = (g.excursion_users ?? []).map(
    (u): ExcursionUser => ({
      id: u.id,
      color: u.color && String(u.color).trim() ? u.color : groupColor,
      comments: u.comments,
    }),
  );
  const payload: ExcursionGroupRequest = {
    excursion_customers,
    excursion_users,
    params: g.params ?? {},
    color: groupColor,
  };
  if (g.id != null) payload.id = g.id;
  if (g.excursion_group_param_id != null)
    payload.excursion_group_param_id = g.excursion_group_param_id;
  return payload;
}

export function baseExcPayload(ex: Excursion): Omit<ExcursionRequest, "groups"> {
  return {
    date: ex.date.slice(0, 10),
    name: ex.name,
    start_time: ex.start_time ?? undefined,
    end_time: ex.end_time ?? undefined,
    color: ex.color ?? undefined,
    location: ex.location ?? undefined,
    description: ex.description ?? undefined,
    status: ex.status ?? undefined,
    cancellation_reason: ex.cancellation_reason ?? undefined,
  };
}

export { groupColorOrFallback };
